// utils
import { makeDownstreamApiCall } from "@swiggy-private/checkout-core";
import { ApiResponse, unwrapResponseWithCode } from "@swiggy-private/core-utils";
import { isEmpty } from "@swiggy-private/core-ui";

// interfaces
import type { IEMIResponse } from "@payment-client/contexts/EmiSelectionContext";

const ENDPOINT = {
    GET_EMI_DETAILS: "/api/v1/cart/emi/details",
};

export interface GetEMIDetailsPayload {
    tenant: string;
    cardReference?: string;
}

export async function getEmiDetails(apiHost: string, payload: GetEMIDetailsPayload): Promise<IEMIResponse> {
    const bodyParams: Record<string, string | number> = {
        tenant: payload.tenant,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ...(!isEmpty(payload.cardReference) && { card_reference: payload.cardReference }),
    };

    const response = (await makeDownstreamApiCall({
        apiHost,
        endpoint: ENDPOINT.GET_EMI_DETAILS,
        options: {
            method: "POST",
        },
        bodyParams,
    })) as ApiResponse<IEMIResponse>;

    return unwrapResponseWithCode(response).toPromise();
}
